<template>
    <div class="z404">
        <div class="icon">
            <!-- <i class="iconfont icon-wuneirong1"></i> -->
            <!-- <img src="https://chain-apply.oss-cn-shanghai.aliyuncs.com/logo/404.png"> -->
            <img src="https://oss.zhulogic.com/logo/404New.png" height="300px" />
        </div>
        <p class="txt" >{{txt}}</p>
    </div>
</template>
<script>
export default {
    name: 'Z404',
    props: {
        txt: {
            type:String,
            default: '网络找不到，刷新试试'
        },
        textVisible: {
            type:Boolean,
            default:false
        }
    }
}
</script>

